export default {"src":"/_next/static/media/store-solid.3fd8dd96.svg","height":24,"width":24};